const invoiceBehaviorIds = {
    UseGraphQLInvoicing: 'UseGraphQLInvoicing',
    CanSeeDetails: 'CanSeeDetails',
    CanResendInvoice: 'CanResendInvoice',
    CanCancelInvoice: 'CanCancelInvoice',
    CanMoveInvoice: 'CanMoveInvoice',
    CanReceivePayment: 'CanReceivePayment',
    CanAddPayment: 'CanAddPayment',
    CanPayInvoice: 'CanPayInvoice',
    CanBatchInvoiceWeek: 'CanBatchInvoiceWeek',
};

export default invoiceBehaviorIds;
